import { render, staticRenderFns } from "./PcPcmClamContent.vue?vue&type=template&id=5f35846c&"
import script from "./PcPcmClamContent.vue?vue&type=script&lang=js&"
export * from "./PcPcmClamContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports